// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* You can add global styles to this file, and also import other style files */
/*** Color Variables *****/
nz-layout.ant-layout {
  height: 100%;
}

/***** Grid View *******/
.grid-view > div {
  padding: 0px 15px;
}
.grid-view .single-featured-property {
  position: relative;
  z-index: 1;
  transition-duration: 500ms;
  overflow: hidden;
  border-radius: 6px;
  box-shadow: 0 10px 20px -10px rgba(0, 0, 0, 0.1);
  border: solid 1px #f1f0f0;
  margin-bottom: 20px;
}
.grid-view .single-featured-property .property-thumb {
  position: relative;
  z-index: 1;
  max-height: 215px;
  display: block;
}
.grid-view .single-featured-property .property-thumb .inner-thumbs {
  display: block;
  position: relative;
  background: #e9ecec;
  min-height: 170px;
  text-align: center;
}
.grid-view .single-featured-property .property-thumb .inner-thumbs img {
  display: block;
  max-width: 100%;
  height: 170px;
  width: 100%;
  object-fit: cover;
}
.grid-view .single-featured-property .property-thumb .inner-thumbs .placeholder-photo {
  margin: 0px auto;
  width: 40px;
  display: block;
  padding: 69px 0px;
}
.grid-view .single-featured-property .property-thumb .inner-thumbs .placeholder-photo img {
  width: 40px;
  height: 32px;
  object-fit: none;
}
.grid-view .single-featured-property .property-thumb .badge {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.42);
  top: 16px;
  right: 16px;
  height: 30px;
  width: 30px;
  display: block;
  border-radius: 50%;
  padding: 0px;
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  cursor: pointer;
}
.grid-view .single-featured-property .property-thumb .badge i {
  color: #fff;
}
.grid-view .single-featured-property .property-thumb .badge:hover {
  background-color: rgba(0, 0, 0, 0.8);
}
.grid-view .single-featured-property .property-thumb .badge.active i {
  color: #4cb8ac;
}
.grid-view .single-featured-property .property-thumb .tag {
  position: absolute;
  height: 26px;
  z-index: 1;
  top: 15px;
  right: 15px;
}
.grid-view .single-featured-property .property-thumb .tag span {
  border-radius: 2px;
  padding: 0 6px;
  color: #4cb8ac;
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  line-height: 26px;
  background: #dff7f9;
}
.grid-view .single-featured-property .property-thumb .tag.salepending span {
  background-color: #fff2dc;
  color: #f5a623;
}
.grid-view .single-featured-property .property-content {
  padding: 20px;
  background: #fff;
  display: block;
}
.grid-view .single-featured-property .property-content .tag {
  position: relative;
  height: 26px;
  text-align: center;
}
.grid-view .single-featured-property .property-content .tag span {
  border-radius: 2px;
  padding: 0 6px;
  color: #4cb8ac;
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  line-height: 26px;
  background: #dff7f9;
}
.grid-view .single-featured-property .property-content .tag.forsale span {
  background-color: #dff7f9;
  color: #4cb8ac;
}
.grid-view .single-featured-property .property-content .tag.salepending span {
  background-color: #fff2dc;
  color: #f5a623;
}
.grid-view .single-featured-property .property-content .tag.contingent span {
  background-color: #f1e7ff;
  color: #bb8eff;
}
.grid-view .single-featured-property .property-content .tag.sold span {
  background-color: #ffebee;
  color: #eb6777;
}
.grid-view .single-featured-property .property-content .tag.withdrawn span {
  background-color: #fff0e2;
  color: #b78151;
}
.grid-view .single-featured-property .property-content .tag.rent span {
  background-color: #e2efff;
  color: #4a90e2;
}
.grid-view .single-featured-property .property-content .list-price {
  position: relative;
  display: block;
  margin-bottom: 12px;
}
.grid-view .single-featured-property .property-content .list-price p {
  color: #4cb8ac;
  padding: 0px;
  font-size: 16px;
  font-weight: 500;
  z-index: 10;
  margin-bottom: 0px;
  line-height: 19px;
}
.grid-view .single-featured-property .property-content .list-price ul {
  margin-top: -1px;
}
.grid-view .single-featured-property .property-content .list-price ul li {
  padding: 0px 3px;
}
.grid-view .single-featured-property .property-content .list-price ul li:last-child {
  padding-right: 0px;
}
.grid-view .single-featured-property .property-content h5 {
  font-size: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  color: #13171f;
  line-height: 24px;
}
.grid-view .single-featured-property .property-content .location {
  color: #acb2be;
  font-size: 14px;
  font-weight: 400;
  margin-top: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 0px;
  line-height: 16px;
}
.grid-view .single-featured-property .property-content .location img {
  margin-right: 6px;
  display: inline-block !important;
  width: auto !important;
  vertical-align: middle;
  height: 16px;
}
.grid-view .single-featured-property .property-content h3 {
  font-size: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  color: #13171f;
  line-height: 19px;
}
.grid-view .single-featured-property .d-flex {
  display: block;
  margin: 0px;
  padding: 16px 20px;
  background: #fff;
  width: 100%;
}
.grid-view .single-featured-property .d-flex img {
  height: 16px;
  margin-right: 5px;
  vertical-align: middle;
  display: inline-block;
}
.grid-view .single-featured-property .d-flex span {
  vertical-align: middle;
  display: inline-block;
}
.grid-view .single-featured-property .d-flex ul {
  text-align: right;
  line-height: 16px;
}
.grid-view .single-featured-property .d-flex ul li {
  font-size: 14px;
  font-weight: 500;
  color: #13192d;
  padding: 0px 4px;
  vertical-align: middle;
}
.grid-view .single-featured-property .d-flex ul li img {
  height: 16px;
  margin-right: 5px;
}
.grid-view .single-featured-property .d-flex .rectangle-icon {
  display: block;
  line-height: 16px;
  margin-top: 0px;
}
.grid-view .single-featured-property .d-flex .rectangle-icon span {
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 500;
  color: #13192d;
  width: 70px;
  overflow: hidden;
  white-space: nowrap;
}
.grid-view .single-featured-property .d-flex .rectangle-icon img {
  vertical-align: middle;
  display: inline-block;
}

.grid-view .single-featured-property:hover,
.single-featured-property:focus {
  box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.05);
  border-color: #4cb8ac;
  background-color: #f9ffff;
  cursor: pointer;
}
.grid-view .single-featured-property:hover .property-content,
.single-featured-property:focus .property-content {
  background-color: #f9ffff;
}
.grid-view .single-featured-property:hover .d-flex,
.single-featured-property:focus .d-flex {
  background-color: #f9ffff;
}

.grid-view .broker-info {
  border-top: 1px solid #e7e9ee !important;
}
.grid-view .broker-info p {
  text-align: center;
  margin: 0px;
  font-size: 12px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #7e828c;
}

.ribbon-wrapper {
  width: 85px;
  height: 88px;
  overflow: hidden;
  position: absolute;
  top: -3px;
  left: -3px;
  z-index: 1;
}
.ribbon-wrapper .ribbon {
  font: bold 15px sans-serif;
  color: #333;
  text-align: center;
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  position: relative;
  padding: 7px 0;
  top: 15px;
  left: -30px;
  width: 120px;
  background-color: #4179bd;
  color: #fff;
}

@media (max-width: 480px) {
  .grid-view > div {
    padding: 0px 0px;
  }
}`, "",{"version":3,"sources":["webpack://./src/variables.scss","webpack://./src/app/sharedmodule/components/favourite-property-list/favourite-property-list.component.scss"],"names":[],"mappings":"AAAA,8EAAA;AAQA,0BAAA;ACNA;EACE,YAAA;AAEF;;AACA,wBAAA;AAEE;EACE,iBAAA;AACJ;AAEE;EACE,kBAAA;EACA,UAAA;EAEA,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gDAAA;EACA,yBAAA;EACA,mBAAA;AAAJ;AAEI;EACE,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;AAAN;AAEM;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAAR;AAEQ;EACE,cAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EAEA,iBAAA;AAAV;AAGQ;EACE,gBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AADV;AAGU;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AADZ;AAMM;EACE,kBAAA;EACA,qCAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;AAJR;AAMQ;EACE,WD/DF;AC2DR;AAOQ;EACE,oCAAA;AALV;AAUQ;EACE,cDvEA;AC+DV;AAYM;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;AAVR;AAYQ;EACE,kBAAA;EACA,cAAA;EACA,cDrFA;ECsFA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;AAVV;AAeQ;EACE,yBD7CO;EC8CP,cD7CQ;ACgClB;AAkBI;EACE,aAAA;EACA,gBAAA;EACA,cAAA;AAhBN;AAkBM;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;AAhBR;AAkBQ;EACE,kBAAA;EACA,cAAA;EACA,cDnHA;ECoHA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;AAhBV;AAqBQ;EACE,yBD7EG;EC8EH,cD7EI;AC0Dd;AAwBQ;EACE,yBDlFO;ECmFP,cDlFQ;AC4DlB;AA2BQ;EACE,yBDvFM;ECwFN,cDvFO;AC8DjB;AA8BQ;EACE,yBD5FA;EC6FA,cD5FC;ACgEX;AAiCQ;EACE,yBDjGK;ECkGL,cDjGM;ACkEhB;AAoCQ;EACE,yBDpGI;ECqGJ,cDpGK;ACkEf;AAsCM;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;AApCR;AAsCQ;EACE,cD5KA;EC6KA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AApCV;AAuCQ;EACE,gBAAA;AArCV;AAsCU;EACE,gBAAA;AApCZ;AAuCU;EACE,kBAAA;AArCZ;AA0CM;EACE,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAxCR;AA2CM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AAzCR;AA2CQ;EACE,iBAAA;EACA,gCAAA;EACA,sBAAA;EACA,sBAAA;EACA,YAAA;AAzCV;AA6CM;EACE,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AA3CR;AA+CI;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AA7CN;AAgDM;EACE,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,qBAAA;AA9CR;AAiDM;EACE,sBAAA;EACA,qBAAA;AA/CR;AAkDM;EACE,iBAAA;EACA,iBAAA;AAhDR;AAkDQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;AAhDV;AAkDU;EACE,YAAA;EACA,iBAAA;AAhDZ;AAqDM;EACE,cAAA;EACA,iBAAA;EACA,eAAA;AAnDR;AAqDQ;EACE,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AAnDV;AAsDQ;EACE,sBAAA;EACA,qBAAA;AApDV;;AAiEA;;EAEE,6CAAA;EACA,qBDjTQ;ECkTR,yBAAA;EACA,eAAA;AA9DF;AAgEE;;EACE,yBAAA;AA7DJ;AAgEE;;EACE,yBAAA;AA7DJ;;AAgEA;EACE,wCAAA;AA7DF;AA8DE;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AA5DJ;;AA+DA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AA5DF;AA8DE;EACE,0BAAA;EACA,WAAA;EACA,kBAAA;EACA,iCAAA;EACA,8BAAA;EACA,6BAAA;EACA,4BAAA;EACA,kBAAA;EACA,cAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,yBD1VQ;EC2VR,WAAA;AA5DJ;;AA+DA;EAEI;IACE,gBAAA;EA7DJ;AACF","sourcesContent":["/* You can add global styles to this file, and also import other style files */\n$import-theme-font: Roboto;\n\n@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap');\n\n$base-font: 'Roboto', sans-serif;\n$heading-font: 'Roboto', sans-serif;\n\n/*** Color Variables *****/\n$dark: #13192d;\n$light: #f9f9f9;\n$light-gray: #eff4f5;\n$white: #fff;\n$black: #000000;\n$primary: #4cb8ac;\n$light-primary: #dff7f9;\n$clight-primary: #e3fbf8;\n$xlight-primary: #f5fbfc;\n$primary-hover: #4cb8ac;\n$secondary: #4179bd;\n$secondary-hover: #3a6daa;\n$placeholder-color: #b7b9c1;\n$alert: #d0031c;\n$pending: #ff7a0a;\n$close: #1f60c3;\n$red: #d0031c;\n$success-green: #52c41a;\n$blue: #0053af;\n$light-blue: #f2fffe;\n$error:#ff4d4f;\n$primary-ghost: #e4f8f9;\n\n$top-nav-color: none;\n$dark-text-clr: #13171f;\n$gray-text-clr: #656c78;\n$gray-text-clr-1: #616b7d;\n$mgray-text-clr: #7e828c;\n$mgray-text-clr-1: #7d8494;\n$lgray-text-clr: #acb2be;\n// $footer-bg: #2f3b3d;\n$footer-bg: #0c1a38;\n$footer-text-clr: rgba(255, 255, 255, 0.59);\n\n$left-nav-clr: #12161f;\n$left-nav-icon: #515b72;\n\n$input-bg: #fcfcfc;\n$input-b-clr: #e8e8e8;\n$input-br-clr: #ccd8db;\n$input-lbl-clr: #566074;\n$checkbox-txt-clr: #5f636c;\n\n$modal-h-clr: #3b414d;\n$detail-bg: #fcfbfb;\n\n$google: #db4437;\n$facebook: #3b5998;\n\n$mail-clr: #4cb8ac;\n$fb-clr: #475993;\n$twt-clr: #03a9f4;\n$in-clr: #0077b7;\n\n$forsale-bg: #dff7f9;\n$forsale-clr: #4cb8ac;\n$salepending-bg: #fff2dc;\n$salepending-clr: #f5a623;\n$contingent-bg: #f1e7ff;\n$contingent-clr: #bb8eff;\n$sold-bg: #ffebee;\n$sold-clr: #eb6777;\n$withdrawn-bg: #fff0e2;\n$withdrawn-clr: #b78151;\n$inreview-bg: #E2EFFF;\n$inreview-clr: #4A90E2;\n$for-rent-bg: #e2efff;\n$for-rent-clr: #4a90e2;\n$offer-pending-clr: #efa92b;\n$offer-pending-bg: #fdf8ed;\n$offer-accepted-clr: #4cb8ac;\n$offer-accepted-bg: #edf7f6;\n\n$primary-color: #3a7ca5;\n$secondary-color: #4cb8ac;\n$background-color: #f4f4f8;\n$text-color: #333;\n$border-color: #e0e0e0;\n$disable-color: #a0a0a0;\n\n$primary-teal: #4CB8AC;\n$primary-teal-hover: #3da396;\n$text-white: white;\n$font-family: 'Roboto', sans-serif;\n$dark-bg: #12161F;\n\n$line-through-text-clr: #71747E;","@use './../../../../variables.scss' as *;\n\nnz-layout.ant-layout {\n  height: 100%;\n}\n\n/***** Grid View *******/\n.grid-view {\n  > div {\n    padding: 0px 15px;\n  }\n\n  .single-featured-property {\n    position: relative;\n    z-index: 1;\n    -webkit-transition-duration: 500ms;\n    transition-duration: 500ms;\n    overflow: hidden;\n    border-radius: 6px;\n    box-shadow: 0 10px 20px -10px rgba(0, 0, 0, 0.1);\n    border: solid 1px #f1f0f0;\n    margin-bottom: 20px;\n\n    .property-thumb {\n      position: relative;\n      z-index: 1;\n      max-height: 215px;\n      display: block;\n\n      .inner-thumbs {\n        display: block;\n        position: relative;\n        background: #e9ecec;\n        min-height: 170px;\n        text-align: center;\n\n        img {\n          display: block;\n          max-width: 100%;\n          height: 170px;\n          width: 100%;\n          -o-object-fit: cover;\n          object-fit: cover;\n        }\n\n        .placeholder-photo {\n          margin: 0px auto;\n          width: 40px;\n          display: block;\n          padding: 69px 0px;\n\n          img {\n            width: 40px;\n            height: 32px;\n            object-fit: none;\n          }\n        }\n      }\n\n      .badge {\n        position: absolute;\n        background-color: rgba(0, 0, 0, 0.42);\n        top: 16px;\n        right: 16px;\n        height: 30px;\n        width: 30px;\n        display: block;\n        border-radius: 50%;\n        padding: 0px;\n        text-align: center;\n        line-height: 30px;\n        font-size: 14px;\n        cursor: pointer;\n\n        i {\n          color: $white;\n        }\n\n        &:hover {\n          background-color: rgba(0, 0, 0, 0.8);\n        }\n      }\n\n      .badge.active {\n        i {\n          color: $primary;\n        }\n      }\n\n      .tag {\n        position: absolute;\n        height: 26px;\n        z-index: 1;\n        top: 15px;\n        right: 15px;\n\n        span {\n          border-radius: 2px;\n          padding: 0 6px;\n          color: $primary;\n          font-size: 14px;\n          font-weight: 500;\n          display: inline-block;\n          line-height: 26px;\n          background: #dff7f9;\n        }\n      }\n\n      .tag.salepending {\n        span {\n          background-color: $salepending-bg;\n          color: $salepending-clr;\n        }\n      }\n    }\n\n    .property-content {\n      padding: 20px;\n      background: #fff;\n      display: block;\n\n      .tag {\n        position: relative;\n        height: 26px;\n        text-align: center;\n\n        span {\n          border-radius: 2px;\n          padding: 0 6px;\n          color: $primary;\n          font-size: 14px;\n          font-weight: 500;\n          display: inline-block;\n          line-height: 26px;\n          background: #dff7f9;\n        }\n      }\n\n      .tag.forsale {\n        span {\n          background-color: $forsale-bg;\n          color: $forsale-clr;\n        }\n      }\n\n      .tag.salepending {\n        span {\n          background-color: $salepending-bg;\n          color: $salepending-clr;\n        }\n      }\n\n      .tag.contingent {\n        span {\n          background-color: $contingent-bg;\n          color: $contingent-clr;\n        }\n      }\n\n      .tag.sold {\n        span {\n          background-color: $sold-bg;\n          color: $sold-clr;\n        }\n      }\n\n      .tag.withdrawn {\n        span {\n          background-color: $withdrawn-bg;\n          color: $withdrawn-clr;\n        }\n      }\n\n      .tag.rent {\n        span {\n          background-color: $for-rent-bg;\n          color: $for-rent-clr;\n        }\n      }\n\n      .list-price {\n        position: relative;\n        display: block;\n        margin-bottom: 12px;\n\n        p {\n          color: $primary;\n          padding: 0px;\n          font-size: 16px;\n          font-weight: 500;\n          z-index: 10;\n          margin-bottom: 0px;\n          line-height: 19px;\n        }\n\n        ul {\n          margin-top: -1px;\n          li {\n            padding: 0px 3px;\n          }\n\n          li:last-child {\n            padding-right: 0px;\n          }\n        }\n      }\n\n      h5 {\n        font-size: 16px;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        width: 100%;\n        overflow: hidden;\n        color: #13171f;\n        line-height: 24px;\n      }\n\n      .location {\n        color: #acb2be;\n        font-size: 14px;\n        font-weight: 400;\n        margin-top: 10px;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        margin-bottom: 0px;\n        line-height: 16px;\n\n        img {\n          margin-right: 6px;\n          display: inline-block !important;\n          width: auto !important;\n          vertical-align: middle;\n          height: 16px;\n        }\n      }\n\n      h3 {\n        font-size: 16px;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        width: 100%;\n        overflow: hidden;\n        color: #13171f;\n        line-height: 19px;\n      }\n    }\n\n    .d-flex {\n      display: block;\n      margin: 0px;\n      padding: 16px 20px;\n      background: #fff;\n      width: 100%;\n      // border-top: 1px solid #efefef;\n\n      img {\n        height: 16px;\n        margin-right: 5px;\n        vertical-align: middle;\n        display: inline-block;\n      }\n\n      span {\n        vertical-align: middle;\n        display: inline-block;\n      }\n\n      ul {\n        text-align: right;\n        line-height: 16px;\n\n        li {\n          font-size: 14px;\n          font-weight: 500;\n          color: #13192d;\n          padding: 0px 4px;\n          vertical-align: middle;\n\n          img {\n            height: 16px;\n            margin-right: 5px;\n          }\n        }\n      }\n\n      .rectangle-icon {\n        display: block;\n        line-height: 16px;\n        margin-top: 0px;\n\n        span {\n          text-overflow: ellipsis;\n          font-size: 14px;\n          font-weight: 500;\n          color: #13192d;\n          width: 70px;\n          overflow: hidden;\n          white-space: nowrap;\n        }\n\n        img {\n          vertical-align: middle;\n          display: inline-block;\n        }\n      }\n    }\n  }\n}\n\n// .grid-view .single-featured-property:hover,\n// .single-featured-property:focus {\n//   box-shadow: 0 0 50px rgba(45, 40, 40, 0.26);\n//   cursor: pointer;\n// }\n\n.grid-view .single-featured-property:hover,\n.single-featured-property:focus {\n  box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.05);\n  border-color: $primary;\n  background-color: #f9ffff;\n  cursor: pointer;\n\n  .property-content {\n    background-color: #f9ffff;\n  }\n\n  .d-flex {\n    background-color: #f9ffff;\n  }\n}\n.grid-view .broker-info {\n  border-top: 1px solid #e7e9ee !important;\n  p {\n    text-align: center;\n    margin: 0px;\n    font-size: 12px;\n    font-weight: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    color: #7e828c;\n  }\n}\n.ribbon-wrapper {\n  width: 85px;\n  height: 88px;\n  overflow: hidden;\n  position: absolute;\n  top: -3px;\n  left: -3px;\n  z-index: 1;\n\n  .ribbon {\n    font: bold 15px sans-serif;\n    color: #333;\n    text-align: center;\n    -webkit-transform: rotate(-45deg);\n    -moz-transform: rotate(-45deg);\n    -ms-transform: rotate(-45deg);\n    -o-transform: rotate(-45deg);\n    position: relative;\n    padding: 7px 0;\n    top: 15px;\n    left: -30px;\n    width: 120px;\n    background-color: $secondary;\n    color: #fff;\n  }\n}\n@media (max-width: 480px) {\n  .grid-view {\n    > div {\n      padding: 0px 0px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
